import React from 'react';
import { Snackbar, Button } from '@mui/material';

interface ConfirmationSnackbarProps {
  open: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
}

const DeleteSnackbar: React.FC<ConfirmationSnackbarProps> = ({
  open,
  message,
  onConfirm,
  onCancel,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      message={message}
      action={
        <>
          <Button onClick={onConfirm} style={{ color: '#ccc' }}  
          >
            Yes
          </Button>
          <Button  onClick={onCancel} style={{ color: '#ccc' }}>
            No
          </Button>
        </>
      }
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      style={{ marginTop: '60px' }}  
    />
  );
};

export default DeleteSnackbar;
